import { useQuery } from '@tanstack/react-query';
import { ReservationPolicyInformation } from '@/models';
import { GuestPortalService } from '@/services/GuestPortal';
import { ClientCookiesStore } from '@/services/client';

const guestPortalService = new GuestPortalService(ClientCookiesStore);

type UseCancellationPolicyParams = {
  propertyId: string;
  reservationId: string;
  languageCode: string;
  enabled?: boolean;
};

export const useCancellationPolicy = ({
  propertyId,
  reservationId,
  languageCode,
  enabled = true,
}: UseCancellationPolicyParams) => {
  const query = useQuery<ReservationPolicyInformation | null>({
    queryKey: [
      'reservation-cancellation-policy',
      propertyId,
      reservationId,
      languageCode,
    ],
    queryFn: () =>
      guestPortalService.getReservationCancellationPolicy(
        propertyId,
        reservationId,
        languageCode,
      ),
    enabled: enabled && Boolean(reservationId),
    retry: false,
    staleTime: 5 * 60 * 1000,
  });

  return {
    policyInformation: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
